export default function Background ({height = 64, width = 64} = {}) {
  const div = document.createElement('div')
  const svg = div.appendChild(SVG('svg'))

  const rect = svg.appendChild(SVG('rect'))

  rect.setAttribute('width', width + 1)
  rect.setAttribute('height', height + 1)
  rect.setAttribute('x', -1)
  rect.setAttribute('y', -1)
  rect.setAttribute('stroke', '#CECED6')
  rect.setAttribute('stroke-dasharray', '2,2')
  rect.setAttribute('fill', 'none')

  svg.setAttribute('width', width)
  svg.setAttribute('height', height)
  svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg')
  svg.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink')

  const content = `
  <?xml version="1.0" encoding="utf-8"?>
  <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
  ${div.innerHTML}
  `.trim()

  return `data:image/svg+xml;base64,${window.btoa(content)}`
}

/**
 * Create SVG element
 */

function SVG (name, attr) {
  const elem = document.createElementNS('http://www.w3.org/2000/svg', name)
  if (!attr) return elem
  Object.keys(attr).forEach(key => {
    const nkey = key.replace(/([a-z])([A-Z])/g, (_, a, b) => `${a}-${b.toLowerCase()}`)
    elem.setAttribute(nkey, attr[key])
  })
  return elem
}



// WEBPACK FOOTER //
// ./src/components/Background.js